// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"32":"9e4a793978561f59","488":"c3b36276a288de0b","655":"379ecdfbb510766c","974":"a97fef63903028e2"}[chunkId] + ".js";
};